const DMI1 = [
    {id: "0", value: "+DI"},    
    {id: "1", value: "-DI"},
    {id: "2", value: "ADX"},    
  ];  
  
  export default DMI1